// extracted by mini-css-extract-plugin
module.exports = {"root":"WeatherCard_root__1GjBr","tempContainer":"WeatherCard_tempContainer__A75xy"};